import { useCallback, useRef, useState } from "react";

import type { RefObject } from "react";

export interface PopoverController {
  handleOpen: () => void;
  handleClose: () => void;
  handleToggle: () => void;
  open: boolean;
}

export function usePopover<T = HTMLElement>(): [RefObject<T | null>, PopoverController] {
  const anchorRef = useRef<T>(null);
  const [open, setOpen] = useState<boolean>(false);

  const handleOpen = useCallback((): void => {
    setOpen(true);
  }, []);

  const handleClose = useCallback((): void => {
    setOpen(false);
  }, []);

  const handleToggle = useCallback((): void => {
    setOpen((prevState) => !prevState);
  }, []);

  return [
    anchorRef,
    {
      handleClose,
      handleOpen,
      handleToggle,
      open,
    },
  ];
}
